import { createSelector } from "reselect"
import { get, chain, identity, keyBy, orderBy } from "lodash"
import { getFactorLabel } from "helpers/factors"
import { getDisabled } from "modules/factor-trends/selectors"
import { getFactorsMetadata, getFavoriteFactors, getFactorCategory } from "modules/factor-trends/selectors/factors"
import { getCurrentPerformance } from "./performance"

export const getComputedFactors = createSelector(
  [getFactorsMetadata, getCurrentPerformance, getDisabled, getFavoriteFactors],
  (factorsMetadata, lastDatum, disabled, favoriteFactors) => {
    const disabledFactors = keyBy(disabled, identity)
    return chain(lastDatum)
      .get("factors")
      .map((performance, id) => ({
        id,
        lastValue: performance,
        label: getFactorLabel(factorsMetadata, id),
        category: get(factorsMetadata, [id, "category"]),
        selectedView: get(factorsMetadata, [id, "selectedView"]),
        favorite: favoriteFactors[id],
        field: `factors.${id}`,
        disabled: !!disabledFactors[id],
        type: "factors",
      }))
      .orderBy(["favorite", (item) => Math.abs(item.lastValue), "id"], ["asc", "desc", "asc"])
      .value()
  },
)

export const getAllCategoryItems = createSelector(
  [getComputedFactors, getFactorCategory],
  (factors, category) => {
    if (category !== "all") {
      return chain(factors)
        .filter(item => item.category === category || item.selectedView === category)
        .orderBy([item => Math.abs(item.lastValue)], ["desc"])
        .value()
    }
    return chain(factors)
      .orderBy([item => Math.abs(item.lastValue)], ["desc"])
      .value()
  },
)

export const getOrderedCategoryItems = createSelector(
  [getAllCategoryItems],
  (items) => orderBy(items, ["favorite", item => Math.abs(item.lastValue), "id"], ["asc", "desc", "asc"]),
)
